import { render, staticRenderFns } from "./Partnership.vue?vue&type=template&id=37d90f38&"
import script from "./Partnership.vue?vue&type=script&lang=js&"
export * from "./Partnership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d90f38')) {
      api.createRecord('37d90f38', component.options)
    } else {
      api.reload('37d90f38', component.options)
    }
    module.hot.accept("./Partnership.vue?vue&type=template&id=37d90f38&", function () {
      api.rerender('37d90f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/partnership/Partnership.vue"
export default component.exports